import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import Typography from '@material-ui/core/Typography';

import { AsyncChipsInput, FormActionButtons } from 'components';

import { deleteRelatedActivities } from 'actions/activityAndAccommodation';

import { ACTIVITIES_TITLES } from 'graphql/queries/activities';

import { useStyles } from 'components/related-accommodations/styles';

const initialValues = {
  relatedActivities: []
};

const RelatedActivities = ({
  handleSubmit,
  setSubmitButton,
  isUpdate,
  ...otherProps
}) => {
  const { deleteRelatedActivities } = otherProps;
  const classes = useStyles();
  const [t] = useTranslation();

  const onDeleteHandler = item => {
    if (item.isCreated) deleteRelatedActivities(item.id);
  };

  return (
    <div className={classes.wrapper}>
      <Typography variant="h1" className={classes.title}>
        {t('Related Activities')}
      </Typography>
      <form onSubmit={handleSubmit}>
        <Field
          name={`relatedActivities`}
          className={classes.inputIndent}
          placeholder="Activities"
          maxLength="255"
          query={ACTIVITIES_TITLES}
          queryName="activities"
          optionLabel="title"
          remove={onDeleteHandler}
          component={AsyncChipsInput}
        />

        <FormActionButtons
          cancelPath="/accommodations-and-activities"
          actionLabel="Next"
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      </form>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  deleteRelatedActivities: id => dispatch(deleteRelatedActivities(id))
});

export default reduxForm({
  form: 'relatedActivitiesForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  touchOnBlur: false,
  initialValues
})(connect(null, mapDispatchToProps)(RelatedActivities));
